import Details from '../../../../assets/src/js/classes/Details';
import '../sass/citrus-faqs.scss';

(() => {
    const $citrusFaqs = document.querySelectorAll('.citrus-faqs');

    if (!$citrusFaqs) return;

    $citrusFaqs.forEach($citrusFaqs => {
        const $faqs = $citrusFaqs.querySelectorAll('.citrus-faqs__faq');

        const initFAQs = () => {
            if (!$faqs) return;

            $faqs.forEach($faqs => {
                new Details($faqs);
            });
        };

        initFAQs();
    });
})();
